import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select.tsx';
import { AvailableI18Languages, TI18Language } from '@/services/i18n/i18n.tsx';

function SelectLanguage() {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (code: TI18Language['code']) => {
    i18n.changeLanguage(code);
    localStorage.setItem('preferredLanguage', code);
  };

  const { code: currentLanguageCode, Icon } = AvailableI18Languages.find(
    (l) => l.code === i18n.language
  ) ?? {
    code: 'en',
  };

  return (
    <Select value={currentLanguageCode} onValueChange={handleLanguageChange}>
      <SelectTrigger className="h-8 w-[120px] bg-white px-2">
        <div className="flex items-center gap-2">
          {Icon ? (
            <Icon className="h-4 w-4 shrink-0" />
          ) : (
            <span className="h-4 w-4 shrink-0"></span>
          )}
          <span className="text-sm">{t(`languages.${currentLanguageCode}`)}</span>
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {AvailableI18Languages.map(({ code, Icon }) => (
            <SelectItem key={code} value={code} className="cursor-default">
              <div className="flex items-center gap-2">
                {Icon ? <Icon className="size-4" /> : <span className="size-4"></span>}
                <span className="text-sm">{t(`languages.${code}`)}</span>
              </div>
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}

export { SelectLanguage };
